import { CoverageEventType } from "@graphql/api";

/**
 * Maps a CoverageEventType to a human-readable string.
 * @param eventType
 */
export const mapEventType = (eventType: CoverageEventType): string => {
  switch (eventType) {
    case CoverageEventType.AddedActive:
      return "Active Policy Added";
    case CoverageEventType.AddedInactive:
      return "Inactive Policy Added";
    case CoverageEventType.Cancellation:
      return "Cancellation";
    case CoverageEventType.Endorsement:
      return "Endorsement";
    case CoverageEventType.NonRenewal:
      return "Non-Renewal";
    case CoverageEventType.Reinstatement:
      return "Reinstatement";
    case CoverageEventType.Renewal:
      return "Renewal";
  }
};
